<template>
  <div>
    <v-row>
      <v-col>
        <s-crud title="Visitas Técnicas" :config="config" edit add height="170" @save="save($event)"
          @rowSelected="rowSelected($event)" remove :filter="filter" search-input number-page="5" ref="crudVist"
          :pdf="selected.length > 0" @pdf="pdf()">
          <!-- @add="addVisit()"
          @edit="editVist($event)"
          addNoFunction -->

          <!-- @click="openReport" -->
          <template v-slot:options>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small elevation="0" @click="openReport()">
                  <v-icon color="default" x-small> mdi-chart-bar </v-icon>
                </v-btn>
              </template>
              <span>Reporte Historico</span>
            </v-tooltip>
          </template>



          <template v-slot:filter>
            <v-card>
              <v-container>
                <v-row>
                  <v-col sm="2" lg="2" cols="12">
                    <s-date label="Fecha Inicio" v-model="filter.VstBeginDate" />
                  </v-col>
                  <v-col sm="2" lg="2" cols="12">
                    <s-date label="Fecha Fin" v-model="filter.VstEndDate" />
                  </v-col>
                  <v-col sm="3" lg="3" cols="12">
                    <s-select-supervice clearable label="Supervisor" v-model="filter.VstSupervisorPrsID" full />
                  </v-col>
                  <v-col sm="2" lg="2" cols="12">
                    <s-select-definition v-model="filter.TypeCultive" :def="1173" clearable label="Tipo Cultivo">
                    </s-select-definition>
                  </v-col>
                  <v-col sm="3" lg="3" cols="12">
                    <s-select-campaign-area full label="Campaña" typeArea="1" v-model="filter.CmaID"
                      :typeCultive="filter.TypeCultive ? (filter.TypeCultive).toString() : '0'" clearable>
                    </s-select-campaign-area>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </template>

          <template slot-scope="props">
            <v-row class="mt-0 mb-0 ml-5 mr-5">
              <v-col sm="2" lg="2" cols="12" class="pb-0 pt-1">
                <s-date label="Fecha" v-model="props.item.VstDate" @input="inputDateVisit($event)"
                  :max="$fun.getDate(0)" />
              </v-col>

              <v-col sm="2" lg="2" cols="12" class="pt-1 pb-0">
                <s-text label="Serie" number v-model="props.item.VstSerie" />
              </v-col>
              <v-col sm="2" lg="2" cols="12" class="pt-1 pb-0">
                <s-text label="Numero" v-model="props.item.VstNumber" number />
              </v-col>
              <v-col sm="4" lg="4" cols="12" class="s-col-form">
                <s-select-supervice clearable label="Supervisor" v-model="props.item.VstSupervisorPrsID" full />
              </v-col>
              <v-col sm="2" lg="2" cols="12" class="pt-1 pb-0">
                <s-text label="ID Programación" number v-model="props.item.TvID" />
              </v-col>
              <v-col sm="2" lg="2" cols="12" class="pb-0 pt-1">
                <s-search-lot-by-cod-senasa @searchSenasa="searchSenasa($event)" :visitDate="props.item.VstDate"
                  :validateAlert="false" />
              </v-col>
              <v-col sm="2" lg="2" cols="12" class="pt-1 pb-0">
                <s-text label="ID Programación" number v-model="props.item.TvID" />
              </v-col>
              <v-col sm="2" lg="2" cols="12" class="pb-0 pt-1">
                <s-search-lot-by-cod-senasa @searchSenasa="searchSenasa($event)" />
              </v-col>

              <v-col sm="2" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="ID Lote" v-model="item.FltID" />
              </v-col>
              <v-col sm="4" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Lote" v-model="item.FltName" />
              </v-col>
              <v-col sm="4" lg="3" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Nombre de Fundo" v-model="item.FagName" />
              </v-col>
              <v-col sm="4" lg="3" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Productor" v-model="item.PrdCardName" />
              </v-col>
              <v-col sm="4" lg="4" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Direccion Fundo" v-model="item.FagAddress" />
              </v-col>

              <v-col sm="4" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Zona" v-model="item.ZonDescription" />
              </v-col>
              <v-col sm="4" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Sub Zona" v-model="item.SzoDescription" />
              </v-col>

              <v-col sm="4" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Variedad" v-model="item.VrtName" />
              </v-col>
              <v-col sm="4" lg="2" cols="12" class="pt-1 pb-0">
                <s-text ref="refCodSenasa" readonly label="Tipo de Cultivo" v-model="item.TypeCropName" />
              </v-col>
            </v-row>
            <v-row class="mb-0 ml-5 mr-5">
              <v-col lg="2" class="pb-0 pt-0 ">
                <s-select-campaign-area clearable label="Campaña" v-model="props.item.GenID" typeArea="1"
                  full></s-select-campaign-area>
              </v-col>
              <v-col lg="2" class=" ">
                <s-switch label="Firma Productor" v-model="props.item.PrdSignature"></s-switch>
              </v-col>
              <v-col lg="12" class="pb-0 pt-0 " v-if="messageFarmLot != ''">

                <v-alert type="warning" variant="tonal">{{ messageFarmLot }}</v-alert>
              </v-col>
            </v-row>
            <v-row class="mt-0 mb-0 ml-5 mr-5">
              <v-col>
                <s-textarea label="Observaciones" v-model="props.item.VstObservation" />
              </v-col>
            </v-row>

          </template>

          <template v-slot:PrdSignature="{ row }">
            <v-chip x-small :color="row.PrdSignature ? 'success' : 'warning'">
              {{ row.PrdSignature ? 'SI' : 'NO' }}
            </v-chip>
          </template>
          <template v-slot:CountApplications="{ row }">
            <v-chip x-small :color="row.CountApplications > 0 ? 'success' : 'warning'">
              {{ row.CountApplications }}
            </v-chip>
          </template>
          <template v-slot:CountPhenological="{ row }">
            <v-chip x-small :color="row.CountPhenological > 0 ? 'success' : 'warning'">
              {{ row.CountPhenological }}
            </v-chip>
          </template>
          <template v-slot:CountActiCult="{ row }">
            <v-chip x-small :color="row.CountActiCult > 0 ? 'success' : 'warning'">
              {{ row.CountActiCult }}
            </v-chip>
          </template>
          <template v-slot:CountPhytoEval="{ row }">
            <v-chip x-small :color="row.CountPhytoEval > 0 ? 'success' : 'warning'">
              {{ row.CountPhytoEval }}
            </v-chip>
          </template>
        </s-crud>

      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!--@change=changeTab($event) @change="clickInTab(item)" --->
        <v-tabs centered height="35" v-model="currentItem">
          <v-tab v-for="itemt in itemsCab" :key="itemt" :href="'#tab-' + itemt">
            {{ itemt }}

          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentItem" style="padding: 10 10px 10px 0px;">
          <v-tab-item v-for="itemt in itemsCab" :key="itemt" :value="'tab-' + itemt">
            <v-card v-if='itemt == "Evaluaciones"' class="pb-5 pt-5">
              <v-tabs height="35" v-model="currentItemOne">
                <v-tab v-for="itemt in itemsOne" :key="itemt" :href="'#tab-' + itemt">
                  {{ itemt }}
                  <v-chip x-small color="info">
                    {{ itemt == "Aplicaciones" ? item.CountApplications : "" }}
                    {{ itemt == "Fenologia" ? item.CountPhenological : "" }}
                    {{ itemt == "Evaluación Fitosanitaria" ? item.CountPhytoEval : "" }}
                    {{ itemt == "Actividades Realizadas" ? item.CountActivi : "" }}
                    {{ itemt == "Evaluación de Instalaciones" ? item.CountInstallEvaluat : "" }}

                  </v-chip>

                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="currentItemOne" style="padding: 10 10px 10px 0px;">
                <v-tab-item v-for="itemt in itemsOne" :key="itemt" :value="'tab-' + itemt">

                  <v-card v-if='itemt == "Aplicaciones"' class="pb-5 pt-5">
                    <visit-applications :Vst="item" @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Actividades Realizadas"' class="pb-5 pt-5">
                    <visit-performed-activities v-if='itemt == "Actividades Realizadas"' :Vst="item"
                      @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Fenologia"' class="pb-5 pt-5">
                    <visit-phenological :Vst="item" @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Evaluación Fitosanitaria"' class="pb-5 pt-5">
                    <visit-phytosanitary-evaluation :Vst="item" @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Evaluación de Instalaciones"' class="pb-5 pt-5">
                    <visit-installation-evaluation :Vst="item" @reload="reload()" />
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <v-card v-if='itemt == "Recomendaciones"' class="pb-5 pt-5">
              <v-tabs height="35" v-model="currentItemTwo">
                <v-tab v-for="itemt in itemsTwo" :key="itemt" :href="'#tab-' + itemt">
                  {{ itemt }}
                  <v-chip x-small color="info">
                    {{ itemt == "Recomendaciónes" ? item.CountRecomen : "" }}
                    {{ itemt == "Actividades culturales" ? item.CountActiCult : "" }}
                    {{ itemt == "Observaciones" ? item.CountRecomObs : "" }}
                  </v-chip>

                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="currentItemTwo" style="padding: 10 10px 10px 0px;">
                <v-tab-item v-for="itemt in itemsTwo" :key="itemt" :value="'tab-' + itemt">

                  <v-card v-if='itemt == "Actividades culturales"' class="pb-5 pt-5">
                    <visit-activity-cultural :Vst="item" @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Recomendaciónes"' class="pb-5 pt-5">
                    <visit-recomendation :Vst="item" @reload="reload()" />
                  </v-card>
                  <v-card v-if='itemt == "Observaciones"' class="pb-5 pt-5">
                    <visit-recomendation-obs :Vst="item" @reload="reload()" />
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-tab-item>
        </v-tabs-items>



      </v-col>
    </v-row>
    <!-- <v-dialog
    
      v-model="dialogVisit"
      permanent
      v-if="dialogVisit"
      persistent
      width="80%"
    >
      <visit-edit
        @close="closeDialogVisit()"
        :isEditabled ="isEdit"
        :visitSchedule="visitEdit"
      ></visit-edit>
    </v-dialog> -->
    <!-- @add="addVisit()" add-no-function  @edit="editVist($event)"@add="addVisit()" -->

    <!--  -->
    <!-- <div class="consent-container"> -->
    <v-dialog v-if="dialogPdf" v-model="dialogPdf" max-width="1100" persistent permanent
      transition="dialog-bottom-transition">
      <PdfVisitsG :VstID="selected.length > 0 ? selected[0].VstID : null" @close="dialogPdf = false" />
    </v-dialog>
    <!-- </div> -->

    <v-dialog v-model="showReportDialogHistoric" max-width="60%" persistent transition="dialog-bottom-transition">
      <v-card rounded="xl" elevation="12">

          <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">

          <span class="text-h6 font-weight-bold">
            Reporte Histórico por Lote y Campaña
          </span>

          <v-btn
            icon
            @click="showReportDialogHistoric = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-title>


        <!-- CONTENIDO -->
        <v-card-text class="pa-6" style="max-height:80vh; overflow-y:auto;">


          <!-- 🔹 OTROS CRUDS EN COLUMNAS -->
          <v-row>

            <v-col cols="12" md="6">
              <v-card elevation="2" rounded="lg" class="pa-4">
                <div class="text-subtitle-2 font-weight-bold mb-3">
                  Aplicaciones Realizadas
                </div>

                    <v-data-table
                      dense
                      :headers="headersVisitPerformedActivities"
                      :items="itemsVisitPerformedActivities"
                      :items-per-page="5"
                      class="elevation-0 mt-5"
                    >

                      <template v-slot:item.VstDate="{ item }">
                      {{ formatDate(item.VstDate) }}
                      </template>

                      <template v-slot:item.PacBeginDate="{ item }">
                        {{ formatDate(item.PacBeginDate) }}
                      </template>

                      <template v-slot:item.PacEndDate="{ item }">
                        {{ formatDate(item.PacEndDate) }}
                      </template>

                    </v-data-table>

              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card elevation="2" rounded="lg" class="pa-4">
                <div class="text-subtitle-2 font-weight-bold mb-3">
                  Evaluación Fitosanitaria
                </div>

                     <v-data-table
                      dense
                      :headers="headersVisitPhytosanitaryEvaluation"
                      :items="itemsVisitPhytosanitaryEvaluation"
                      :items-per-page="5"
                      class="elevation-0 mt-5"
                    >

                    <template v-slot:item.VstDate="{ item }">
                      {{ formatDate(item.VstDate) }}
                    </template>


                    </v-data-table>
              </v-card>
            </v-col>

          </v-row>

          <!-- 🔹 FILA EXTRA POR SI AGREGAS MÁS -->
          <v-row class="mt-4">

            <v-col cols="12" md="12">
              <v-card elevation="2" rounded="lg" class="pa-4">
                <div class="text-subtitle-2 font-weight-bold mb-3">
                  Recomendaciones
                </div>
             
                     <v-data-table
                      dense
                      :headers="headersVisitRecomendationHead"
                      :items="itemsVisitRecomendationHead"
                      :items-per-page="5"
                      class="elevation-0 mt-5"
                    >

                    <template v-slot:item.VstDate="{ item }">
                      {{ formatDate(item.VstDate) }}
                    </template>

                    </v-data-table>

              </v-card>
            </v-col>


          </v-row>

        </v-card-text>


      </v-card>
    </v-dialog>


    <visit-form-modal v-model="showVisitModal" :visit-data="visitDataForModal" :is-edit="isEditMode" :pl-id="PlID"
      @saved="onVisitSaved" @close="onVisitModalClose" />


  </div>
</template>


<script>
import VisitEdit from "@/views/TechnicalAssistance/Visits/VisitEdit";
import VisitApplications from "@/views/TechnicalAssistance/Visits/VisitApplications";
import VisitPhenological from "@/views/TechnicalAssistance/Visits/VisitPhenological";
import VisitPhytosanitaryEvaluation from "@/views/TechnicalAssistance/Visits/VisitPhytosanitaryEvaluation";
import VisitActivityCultural from "@/views/TechnicalAssistance/Visits/VisitActivityCultural";
import VisitRecomendation from "@/views/TechnicalAssistance/Visits/VisitRecomendation";
import VisitPerformedActivities from "@/views/TechnicalAssistance/Visits/VisitPerformedActivities";
import VisitInstallationEvaluation from "@/views/TechnicalAssistance/Visits/VisitInstallationEvaluation";
import VisitRecomendationObs from "@/views/TechnicalAssistance/Visits/VisitRecomendationObs";

import _sServices from "@/services/Technicalassistance/Visit/Visit.js";
import SSelectSupervice from "@/components/HarvestSchedule/SSelectSupervice";
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectCampaignArea from "../../../components/Utils/SSelectCampaignArea.vue";

import VisitFormModal from "@/views/TechnicalAssistance/Visits/VisitFormModal.vue";
// import PdfVisitsG from "@/views/TechnicalAssistance/Visits/PdfVisitsG.vue";
import PdfVisitsG from "./PdfVisitsG.vue";

export default {
  name: "RequirementServiceTasPaymentCategoryService",
  components: {
    VisitEdit,
    VisitApplications,
    SSelectSupervice,
    SSearchLotByCodSenasa,
    VisitPhenological,
    VisitPhytosanitaryEvaluation,
    VisitActivityCultural,
    VisitRecomendation,
    VisitPerformedActivities,
    VisitInstallationEvaluation,
    VisitRecomendationObs,
    SSelectCampaignArea,
    VisitFormModal,
    PdfVisitsG
  },
  props: {
    PlID: { type: Number, default: 0 },
  },

  data() {
    return {
      currentItem: 'tab-Funciones',
      currentItemOne: 'tab-Evaluaciones',
      currentItemTwo: 'tab-Recomendaciones',
      itemsOne: ['Aplicaciones', 'Fenologia', 'Evaluación Fitosanitaria', 'Actividades Realizadas', 'Evaluación de Instalaciones'],
      itemsTwo: ['Recomendaciónes', 'Actividades culturales', 'Observaciones'],
      itemsCab: ['Evaluaciones', 'Recomendaciones'],
      item: {
      },
      isEdit: false,
      visitEdit: {},
      dialogVisit: false,
      filter: { VstBeginDate: null, VstEndDate: null, CmaID: null, TypeCultive: null },
      messageFarmLot: "",
      dateAlert: "1990-01-01",
      showVisitModal: false,
      visitDataForModal: {},
      isEditMode: false,
      dialogPdf: false,
      selected: [],
      showReportDialogHistoric: false,
      headersVisitPerformedActivities: [
        { text: "Fecha Visita", value: "VstDate", width: 70, align: "center", sortable: false },
        { text: "Actividad", value: "TypeActivityName", width: 40, sortable: false, },
        { text: "Fecha Inicio", value: "PacBeginDate", width: 80, sortable: false, },
        { text: "Fecha Fin", value: "PacEndDate", width: 80, sortable: false, }
      ],
      itemsVisitPerformedActivities: [],

      itemsVisitPhytosanitaryEvaluation: [],
      headersVisitPhytosanitaryEvaluation: [
        { text: "Fecha Visita", value: "VstDate", width: 70, align: "center", sortable: false },
        { text: "Plaga / Enfermedad", value: "PlagueName", width: 40, sortable: false, },
        { text: "Organo de planta", value: "TypeOrganPlantName", width: 80, sortable: false, },
        { text: "Porcentaje", value: "PhePercentage", width: 80, sortable: false, }
      ],
      itemsVisitRecomendationHead: [],
      headersVisitRecomendationHead: [
        { text: "Fecha Visita", value: "VstDate", width: 70, align: "center", sortable: false },
        { text: "Recomendación", value: "RchNote", width: 40, sortable: false, },
        { text: "Tipo de aplicación", value: "TypeApplicationName", width: 80, sortable: false, },
        { text: "Enfermedad/Plaga/Maleza", value: "PlagueName", width: 80, sortable: false, },
        { text: "Producto", value: "Supplie", width: 80, sortable: false, },
        { text: "Dosis", value: "RcmDose", width: 80, sortable: false, }
      ],

    };
  },

  computed: {
    config() {
      return {
        model: {
          //RETORNAR PROPIEDAD COMPUTADA
          VstID: "ID",
          VstDate: "date",
          DedDescription: "string",
          Estado: "string",
          PcStatus: "status",
          CountApplications: "number",
          CountPhenological: "number",
          CountActiCult: "number",
          CountPhytoEval: "number",
          PrdSignature: "number",
          //
        },
        service: _sServices,
        headers: [
          //Vista de tabla para admin
          { text: "ID", value: "VstID", sortable: false },
          { text: "Fecha", value: "VstDate", sortable: false },
          { text: "Serie", value: "VstSerie", sortable: false },
          { text: "Numero Doc.", value: "VstNumber", sortable: false },
          { text: "Supervisor", value: "NtpSupervisorName", sortable: false },
          // { text: "Aplic.", value: "CountApplications", sortable: false }, 
          // { text: "Fenologia.", value: "CountPhenological", sortable: false }, 
          // { text: "Act. Cult", value: "CountActiCult", sortable: false },  
          // { text: "Eval Fisi.", value: "CountPhytoEval", sortable: false },  
          { text: "ID Lote", value: "FltID", sortable: false },
          { text: "Lote", value: "FltName", sortable: false },
          { text: "Fundo", value: "FagName", sortable: false },
          { text: "Zona", value: "ZonDescription", sortable: false },
          { text: "Sub Zona", value: "SzoDescription", sortable: false },
          { text: "Firma Prod.", value: "PrdSignature", sortable: false },
          { text: "Campaña", value: "CmaName", sortable: false },
        ],
      };
    },
  },

  methods: {
    inputDateVisit(date) {

      this.dateAlert = date;



      if (this.item.FltID) {


        var lot = this.item;
        lot.VstDate = date;
        this.getVisitFarmLot(lot);
      }
    },
    reload() {
      this.$refs.crudVist.refresh();
    },
    searchSenasa(lot) {
      if (lot == null) return;
      // console.log("lot lot", lot)
      this.item = lot;

      this.item.TypeCropName = lot.TypeCropText;
      this.item.VrtName = lot.VrtDescription;
      this.item.ZonDescription = lot.ZonIDText;
      this.item.SzoDescription = lot.SzoIDText;

      lot.VstDate = this.dateAlert;


      this.getVisitFarmLot(lot);
    },
    getVisitFarmLot(lot) {
      this.messageFarmLot = "";
      _sServices.getVisitFarmLot(lot, this.$fun.getUserID()).then((r) => {

        if (r.status == 200) {

          if (r.data.VstID > 0) {
            this.messageFarmLot = "Ultima Visita del Productor: " + this.$fun.formatDateView(r.data.VstDate) + ", Dias: " + r.data.DaysLastDateVisit;

          }
        }
      });
    },
    rowSelected(rows) {
      this.selected = rows;
      this.item = {};
      if (rows.length > 0) {
        this.visitEdit = rows[0];

        this.item = rows[0];
        this.item.GenID = this.item.CmaID;
        // console.log('item', this.item);
      }
    },

    editVist(item) {
      this.isEdit = true;
      this.dialogVisit = true;
      this.visitEdit = item;
    },

    addVisit() {

      // this.isEdit = false;
      // this.dialogVisit = true;
      // this.visitEdit = {};

    },

    closeDialogVisit() {
      this.dialogVisit = false;
      this.$refs.crudVist.refresh();
    },

    save(visit) {

      // console.log("visit visit", visit)
      if (visit.VstSerie.length == 0) {
        this.$fun.alert("Debe ingresar una Serie", "warning")
        return;
      }
      if (visit.VstNumber.length == 0) {
        this.$fun.alert("Debe ingresar un numero de documento", "warning")
        return;
      }

      let fltid = this.item.FltID ? parseInt(this.item.FltID) : 0;
      if (fltid == 0 || fltid == undefined) {
        this.$fun.alert("Debe seleccionar un Lote", "warning")
        return;
      }

      if (visit.VstSupervisorPrsID == null) {
        this.$fun.alert("Debe seleccionar un Supervisor", "warning")
        return;
      }

      visit.FltID = fltid;
      visit.PlID = this.PlID;
      visit.ZonID = this.item.ZonID;
      visit.SzoID = this.item.SzoID;

      visit.CmaID = visit.GenID;


      visit.save().then((r) => {
        this.item = {};

      });
    },

    addVisit() {
      this.isEditMode = false;
      this.visitDataForModal = {};
      this.showVisitModal = true;
    },

    editVist(item) {
      this.isEditMode = true;
      this.visitDataForModal = item;
      this.showVisitModal = true;
    },

    onVisitSaved(visitData) {
      // Método que se ejecuta cuando se guarda la visita
      // console.log('Visita guardada:', visitData);
      this.reload();
    },

    onVisitModalClose() {
      this.showVisitModal = false;
      this.visitDataForModal = {};
      this.reload();
    },
    pdf() {
      console.log(this.selected);
      this.dialogPdf = true;
      console.log('Generar PDF');
      // _AdvanceProducerService.byID({ AdpID: this.selected[0].AdpID }, this.$fun.getUserID()).then(res => {
      //   if (res.status == 200) {
      //     this.dataPrint = res.data;

      //   }
      // });
    },
    openReport() {
      if (this.selected && this.selected.length>0){
        this.loadlistTasVisitPerformedActivities();
        this.loadListVisitPhytosanitaryEvaluationHistoricalReport();
        this.loadListVisitRecomendationHistoricalReport();
        this.showReportDialogHistoric=true;
      };
    },
    loadlistTasVisitPerformedActivities(){

      _sServices
      .listTasVisitPerformedActivitiesHistoricalReport(this.selected[0].FltID,this.selected[0].CmaID, this.$fun.getUserID())
      .then((response) => {

        let dataM = response.data;
        this.itemsVisitPerformedActivities = [];

        dataM.forEach((element) => {
          let obj = {
            VstDate: element.VstDate,
            TypeActivityName: element.TypeActivityName,
            PacBeginDate: element.PacBeginDate,
            PacEndDate: element.PacEndDate,
          };
          this.itemsVisitPerformedActivities.push(obj);

        });

      });
    },
    loadListVisitPhytosanitaryEvaluationHistoricalReport(){

      _sServices
      .listTasVisitPhytosanitaryEvaluationHistoricalReport(this.selected[0].FltID,this.selected[0].CmaID, this.$fun.getUserID())
      .then((response) => {

        let dataM = response.data;
        this.itemsVisitPhytosanitaryEvaluation = [];

        dataM.forEach((element) => {
          let obj = {
            VstDate: element.VstDate,
            PlagueName: element.PlagueName,
            TypeOrganPlantName: element.TypeOrganPlantName,
            PhePercentage: element.PhePercentage,
          };
          this.itemsVisitPhytosanitaryEvaluation.push(obj);

        });

      });
    },
    loadListVisitRecomendationHistoricalReport(){

      _sServices
      .listTasVisitRecomendationHistoricalReport(this.selected[0].FltID,this.selected[0].CmaID, this.$fun.getUserID())
      .then((response) => {

        let dataM = response.data;
        this.itemsVisitRecomendationHead = [];

        dataM.forEach((element) => {
          let obj = {
            VstDate: element.VstDate,
            RchNote: element.RchNote,
            TypeApplicationName: element.TypeApplicationName,
            PlagueName: element.PlagueName,
            Supplie: element.Supplie,
            RcmDose: element.RcmDose
          };
          this.itemsVisitRecomendationHead.push(obj);

        });

      });
    },
    formatDate(date) {
      if (!date) return ""

      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()

      return `${day}/${month}/${year}`
    },
  },
  watch: {},
  created() { },
  mounted() {

  }
};
</script>

<style scoped>
.consent-container {
  background: #f5f7fa;
  min-height: 100vh;
  border-radius: 10px;
}

/* Header Styles */
.page-header {
  /* background: white; */
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-bottom: 1px solid #e1e8ed;
  border-radius: 10px;
  padding: 24px 32px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-text {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  font-size: 14px;
  color: #c1d1e9;
  margin: 4px 0 0 0;
}

.search-field {
  max-width: 300px;
}

.search-field>>>.v-input__control {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 25px;
}

.search-field>>>.v-input__control .v-input__slot {
  background: transparent !important;
  color: white;
}

.search-field>>>input {
  color: white !important;
}

.search-field>>>input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-field>>>.v-icon {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Content Wrapper */
.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

/* Card Sections */
.filter-section,
.results-section {
  background: white;
  border-radius: 12px;
  border: 1px solid #e1e8ed;
  overflow: hidden;
}

.section-header {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}

.filter-label {
  font-size: 12px;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Table Styles */
.consent-table {
  border-radius: 0;
}

.consent-table>>>.v-data-table__wrapper {
  border-radius: 0;
}

.consent-table>>>thead th {
  background: #f7fafc !important;
  color: #4a5568 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0 !important;
  height: 56px;
  padding: 0 16px !important;
}

.consent-table>>>tbody tr {
  transition: all 0.2s ease;
}

.consent-table>>>tbody tr:hover {
  background: #f7fafc !important;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.consent-table>>>tbody tr.v-data-table__selected {
  background: #ebf8ff !important;
}

.consent-table>>>tbody td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

.cell-content {
  display: flex;
  align-items: center;
}

.name-cell {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

/* Dialog */
::v-deep(.v-dialog--fullscreen) {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .page-header {
    padding: 16px 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
  }

  .header-left {
    justify-content: center;
  }

  .header-text {
    text-align: center;
  }

  .search-input {
    width: 100%;
  }

  .content-wrapper {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 600px) {
  .header-title {
    font-size: 20px;
  }

  .header-subtitle {
    font-size: 13px;
  }

  .consent-table>>>tbody td {
    padding: 8px !important;
  }
}

/* Dark Theme Support */
.theme--dark .consent-container {
  background: #1a1a1a;
}

.theme--dark .page-header {
  background: #2d2d2d;
  border-bottom-color: #404040;
}

.theme--dark .header-title {
  color: #e1e8ed;
}

.theme--dark .header-subtitle {
  color: #a0aec0;
}

.theme--dark .filter-section,
.theme--dark .results-section {
  background: #2d2d2d;
  border-color: #404040;
}

.theme--dark .section-title {
  color: #e1e8ed;
}

.theme--dark .filter-label {
  color: #a0aec0;
}

.theme--dark .consent-table>>>thead th {
  background: #1a1a1a !important;
  color: #e1e8ed !important;
  border-bottom-color: #404040 !important;
}

.theme--dark .consent-table>>>tbody tr:hover {
  background: #363636 !important;
}

.theme--dark .consent-table>>>tbody tr.v-data-table__selected {
  background: #1e3a5f !important;
}

.theme--dark .consent-table>>>tbody td {
  border-bottom-color: #404040 !important;
}
</style>